import {
  Database as DatabaseIcon,
  Shield as ShieldIcon,
  AlertTriangle as AlertTriangleIcon,
} from 'react-feather'

import theme from 'theme'

const NECESSARY_ID = 3
const ANALYTICAL_PERFORMANCE_ID = 5
const FUNCTIONALITY_ID = 6
const ADVERTISING_ID = 7
const UNKNOWN_ID = 10

const NECESSARY_LABEL = 'Necessários'
const ANALYTICAL_PERFORMANCE_LABEL = 'Analíticos ou de desempenho'
const FUNCTIONALITY_LABEL = 'Funcionalidade'
const ADVERTISING_LABEL = 'Publicidade'
const UNKNOWN_LABEL = 'Outros'

const ANALYTICAL_PERFORMANCE_KEY = 'analytics'
const FUNCTIONALITY_KEY = 'functionality'
const ADVERTISING_KEY = 'advertising'
const UNKNOWN_KEY = 'unknown'

const SECURITY_STORAGE_TYPE = 'security_storage'
const ANALYTICAL_PERFORMANCE_TYPE = 'analytics_storage'
const FUNCTIONALITY_TYPE = 'functionality_storage'
const ADVERTISING_TYPE = 'ad_storage'

const VALID_CATEGORIES = [
  NECESSARY_ID,
  ANALYTICAL_PERFORMANCE_ID,
  FUNCTIONALITY_ID,
  ADVERTISING_ID,
]

const AUTO_BLOCK_FIXED_CATEGORIES = [
  FUNCTIONALITY_KEY,
  ANALYTICAL_PERFORMANCE_KEY,
  ADVERTISING_KEY,
]

const MENU_ITEMS = [
  {
    id: NECESSARY_ID,
    name: NECESSARY_LABEL,
    translateKey: 'menu.cookieSection.necessary.title',
    alwaysActive: true,
  },
  {
    id: FUNCTIONALITY_ID,
    name: FUNCTIONALITY_LABEL,
    translateKey: 'menu.cookieSection.functionality.title',
  },
  {
    id: ADVERTISING_ID,
    name: ADVERTISING_LABEL,
    translateKey: 'menu.cookieSection.marketing.title',
  },
  {
    id: ANALYTICAL_PERFORMANCE_ID,
    name: ANALYTICAL_PERFORMANCE_LABEL,
    translateKey: 'menu.cookieSection.analytics.title',
  },
  {
    id: UNKNOWN_ID,
    name: UNKNOWN_LABEL,
    translateKey: 'menu.cookieSection.others.title',
  },
]

const STORAGE_TYPES = {
  [NECESSARY_ID]: SECURITY_STORAGE_TYPE,
  [ANALYTICAL_PERFORMANCE_ID]: ANALYTICAL_PERFORMANCE_TYPE,
  [FUNCTIONALITY_ID]: FUNCTIONALITY_TYPE,
  [ADVERTISING_ID]: ADVERTISING_TYPE,
  [UNKNOWN_ID]: '', // Categoria desconhecida não tem storage type específico
}

const COOKIE_STATS_CONFIG = [
  {
    key: 'total',
    icon: DatabaseIcon,
    label: 'Total de Cookies',
    backgroundColor: theme.palette.info.light,
  },
  {
    key: 'classified',
    icon: ShieldIcon,
    label: 'Cookies Classificados',
    backgroundColor: theme.palette.success.light,
  },
  {
    key: 'unknown',
    icon: AlertTriangleIcon,
    label: 'Cookies Não Classificados',
    backgroundColor: theme.palette.warning.light,
  },
]

const categories = {
  ADVERTISING_ID,
  ANALYTICAL_PERFORMANCE_ID,
  AUTO_BLOCK_FIXED_CATEGORIES,
  COOKIE_STATS_CONFIG,
  FUNCTIONALITY_ID,
  MENU_ITEMS,
  NECESSARY_ID,
  STORAGE_TYPES,
  UNKNOWN_ID,
  UNKNOWN_KEY,
  VALID_CATEGORIES,
}

export default categories
